import type { CreateSupplierRequest, Supplier } from '@nucleus-commerce/api-client/platform';

import type { SupplierInput, SupplierValues } from '../schemas/supplier-schema';

export function supplierFormFor(supplier: Supplier | null): SupplierInput {
  return {
    name: supplier?.name ?? '',
    currency: supplier?.currency ?? 'USD',
    leadTimeDays:
      supplier?.leadTimeDays === null || supplier === null ? '' : String(supplier.leadTimeDays),
    notes: supplier?.notes ?? '',
  };
}

/** Blank lead time and notes are sent as null, which clears them on an update. */
export function toSupplierRequest(values: SupplierValues): CreateSupplierRequest {
  return {
    name: values.name,
    currency: values.currency,
    leadTimeDays: values.leadTimeDays === '' ? null : Number(values.leadTimeDays),
    notes: values.notes.trim() === '' ? null : values.notes,
  };
}

/** Largest CSV the backend reads in one request (characters). */
export const MAX_CSV_LENGTH = 5_000_000;
